export interface ConsultationInitDecision {
  /**
   * Whether the boot should create a fresh case and reset the in-progress
   * questionnaire form/index. True only when there is no active case.
   */
  shouldResetForNewCase: boolean;
}

/**
 * Pure decision describing what the Consultation page should reset on boot.
 *
 * Extracted from the page so the create-vs-load decision can be unit-tested
 * without rendering the whole Consultation tree.
 *
 * Note what this deliberately does NOT include: clearing a previously-uploaded
 * guardian photo ID (driver_license_id). The ID persists to localStorage while
 * the case persists to sessionStorage, so an empty-session or second-tab boot
 * finds no active case but a lingering ID; erasing it there silently drops a
 * valid upload while the patient is still on Parental Consent (ZD-3226 /
 * ZD-3209). Boot therefore never touches the ID — it is reset only on explicit
 * logout (clearUser).
 *
 * Cross-consultation isolation is enforced separately, at the Parental Consent
 * READ: the uploaded ID is stamped with its owning case id (driver_license_case)
 * and is only treated as "uploaded" when that marker matches the active case.
 * So a new consultation never inherits a prior consultation's ID, without boot
 * ever clearing anything.
 */
export const decideConsultationInit = (
  caseId?: string | number | null
): ConsultationInitDecision => ({
  shouldResetForNewCase: !caseId,
});
